import { i18n, inject, observer, pr, React, RouteComponentProps, ui } from "aaa";
import { MessageScreen } from "components/common/MessageScreen";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { TradingPreferencesStore } from "./TradingPreferencesStore";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
    store: TradingPreferencesStore;
}

@inject("externalInterfaceStore")
@observer
export class TradingPreferencesSuccess extends React.Component<IProps & i18n.InjectedIntlProps & RouteComponentProps<{}>, {}> {
    render() {
        return (
            <MessageScreen
                icon={pr.IconMessageOk}
                useWebVersion
                variant="success"
                message={ui.__("tradingPreferences.success.text")}
                buttonLabelId="common.backToGeorgeGo"
                onDismiss={() => this.props.externalInterfaceStore.raiseExitSuccess()}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/tradingPreferences/TradingPreferencesSuccess.tsx